import React from 'react';
import { PageContainer, PageTitle, Card } from 'styles/common.styles';

const ParameterList = () => (
  <PageContainer>
    <PageTitle>규정 파라미터</PageTitle>
    <Card style={{ padding: 24 }}>L1/L2 기관 파라미터 관리 — ADM-003 (다음 스프린트)</Card>
  </PageContainer>
);

export default ParameterList;
